<template>
  <!-- 文件上传组件封装 -->
  <div class="upload_box">
    <el-upload ref="upload" :data="uploadData" :action="url" multiple :limit="limit" :file-list="files" :on-exceed="handleExceed"
      :before-upload="handleBeforeUpload" :before-remove="handleRemove" :on-progress="handleFileUploadProgress"
      :on-success="handleFileSuccess">


      <!-- //插槽，自定义鼠标经过显示的按钮 -->
      <template slot="file" slot-scope="{ file }">
        <div class="custom-file-item">
          <!-- 根据文件后缀判断显示哪个图标 -->
          <svg v-if="getFileIcon(file.name) === 'image'" class="icon" aria-hidden="true">
            <use xlink:href="#icon-image"></use>
          </svg>
          <svg v-else-if="getFileIcon(file.name) === 'pdf'" class="icon" aria-hidden="true">
            <use xlink:href="#icon-pdf"></use>
          </svg>
          <svg v-else-if="getFileIcon(file.name) === 'word'" class="icon" aria-hidden="true">
            <use xlink:href="#icon-word"></use>
          </svg>
          <svg v-else class="icon" aria-hidden="true">
            <use xlink:href="#icon-file"></use>
          </svg>

          <!-- 显示文件名 -->
          <span class="el-upload-list__item-name">{{ file.name }}</span>
          <!-- 删除按钮 -->
          <i class="el-icon-delete" @click.stop="handleRemove(file)"></i>
        </div>
      </template>
      <el-button icon="el-icon-upload2" class="upload-btn">上傳檔案 Upload file
      </el-button>
    </el-upload>
  </div>
</template>

<script>
  import {
    deleteFile
  } from "@/assets/js/api.js";
  export default {
    props: {
      //限制上传文件数量
      limit: Number,
      //父组件传入的文件列表
      files: {
        type: Array,
        default: () => []
      },
      //控件名
      uploadName: String,
      //附件所属名字
      fileLabel: String,
    },
    created() {
      // console.log(JSON.stringify(this.files))
      this.uploadName
    },
    data() {
      return {
        url: process.env.VUE_APP_BASE_API + "app-api/infra/file/file-upload",
        uploadData: { path: "" } // 初始化为空，由 before-upload 动态填充
      }
    },
    methods: {
      // 文件上传中处理
      handleFileUploadProgress(event, file, fileList) {},
      // 文件上传成功处理
      handleFileSuccess(response, file, fileList) {
        let uploadRes = response.data
        console.log(uploadRes)
        uploadRes.name = file.name,
          uploadRes.uid = file.uid,
          uploadRes.fileLabel = this.fileLabel,
          this.files.push(uploadRes)
        this.$emit('handFileUpload', {
          fieldName: this.uploadName,
          files: this.files
        })
        console.log(JSON.stringify(this.files))

      },
      handleRemove(file, fileList) {
        for (var i = 0; i < this.files.length; i++) {
          if (this.files[i].uid === file.uid) {
            //刪除服務端
            deleteFile(file.fileId).then(res => {
            })
            this.files.splice(i, 1);

          }
        }
      },
      handleBeforeUpload(file) {
        //先校验文件格式
        let fileName = file.name
        let pos = fileName.lastIndexOf('.')
        let lastName = fileName.substring(pos, fileName.length)
        if (
          lastName.toLowerCase() !== '.pdf' &&
          lastName.toLowerCase() !== '.png' &&
          lastName.toLowerCase() !== '.jpg' &&
          lastName.toLowerCase() !== '.jpeg' &&
          lastName.toLowerCase() !== '.doc' &&
          lastName.toLowerCase() !== '.docx'
        ) {
          this.$message.warning('請檢查上傳檔案及其內容是否齊全， 僅⽀援PDF、PNG、JPG、JPEG、DOC 及 DOCX檔案格式')
          return false
        }
        //再校验文件大小
        const maxSize = 5 * 1024 * 1024; // 5MB，根据你的需求设置最大文件大小
        if (file.size > maxSize) {
          this.$message.warning(`請上傳少於${maxSize / (1024 * 1024)}MB的檔案`);
          return false;
        }



         // 处理文件名：添加时间戳
        const timestamp = this.parseTime(new Date(),'{y}{m}{d}{h}{i}{s}');
        const fileNameWithoutExt = fileName.substring(0, pos);
        const newFileName = `${fileNameWithoutExt}_${timestamp}${lastName}`;

        // 动态拼接 path: applyCode/filename
        this.uploadData.path = `${this.Session.get('applyCode') || ''}/${newFileName}`;
        return true; // 必须返回 true 才会继续上传

      },
      handleExceed(files, fileList) {
        this.$message.warning(
          `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
        );
      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${file.name}？`);
      },
      getFileIcon(fileName) {
        const ext = fileName.slice(fileName.lastIndexOf('.') + 1).toLowerCase(); // 获取文件后缀并转换为小写
        switch (ext) {
          case 'jpg':
          case 'jpeg':
          case 'png':
          case 'gif':
          case 'bmp':
            return 'image'; // 图片文件
          case 'pdf':
            return 'pdf'; // PDF文件
          case 'doc':
          case 'docx':
            return 'word'; // WORD文件
          default:
            return 'default'; // 其他文件
        }
      }
    }

  }

</script>

<style scoped>
  .icon {
    width: 1.2em;
    height: 1.2em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }

  .el-button:focus,
  .el-button:hover {
    background: #F1F1F1;
    border-color: #F1F1F1;
    color: var(--Overlays-Default, #00000033);
  }

  .custom-file-item {
    display: flex;
    align-items: center;
    line-height: 35px;
  }


  .custom-icon {
    margin-right: 8px;
    font-size: 24px;
    /* 或者你可以根据需求设置不同的颜色 */
  }

</style>



// WEBPACK FOOTER //
// src/components/FileUpload/index.vue